import { lazy, Suspense } from 'react';

import { DiscordInvite, SkipLink, Spinner } from '@game/ui';
import type { JSX } from 'react';
import { Redirect, Route, Switch } from 'wouter';

import { SiteLogo } from '@components/SiteLogo/SiteLogo';
import * as PATHS from '@constants/paths';

import { Landing } from '../Landing/Landing';

const RecoverPass = lazy(() => import('../RecoverPass/RecoverPass'));
const Register = lazy(() => import('../Register/Register'));
const Login = lazy(() => import('../Login/Login'));
const Media = lazy(() => import('../Screenshots/Screenshots'));
const AuthManagement = lazy(() => import('../AuthManagement/AuthManagement'));
const AccountManagement = lazy(() => import('../AccountManagement/AccountManagement'));
const PrivacyPolicy = lazy(() => import('../PrivacyPolicy/PrivacyPolicy'));
const Rules = lazy(() => import('../Rules/Rules'));

import { NavLink } from '@components/NavLink/NavLink';

import './Public.less';

const Public = (): JSX.Element => {
  return (
    <Suspense fallback={<>Loading</>}>
      <div className="public-background">
        <div className="public-wrapper">
          <main className="public-content">
            <Switch>
              <Route path={PATHS.REGISTER}>
                <SkipLink target="registration" text="Skip to registration" />
              </Route>
              <Route path={PATHS.LOGIN}>
                <SkipLink target="login" text="Skip to login" />
              </Route>
            </Switch>
            <div className="public-topbar">
              <DiscordInvite href={PATHS.DISCORD_INVITE} />
              <ul>
                <li>
                  <NavLink to="/" title="Home">
                    /
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/login">Login</NavLink>
                </li>
                <li>
                  <NavLink to="/register">Register</NavLink>
                </li>
                <li>
                  <NavLink to="/screenshots">Media</NavLink>
                </li>
              </ul>
            </div>
            <SiteLogo />
            <div className="content">
              <Suspense fallback={<Spinner size="large" centered />}>
                <Switch>
                  <Route path={`${PATHS.ACCOUNT_MANAGEMENT}/*?`}>
                    <AccountManagement />
                  </Route>
                  <Route path={`${PATHS.AUTH_MANAGEMENT}/*?`}>
                    <AuthManagement />
                  </Route>
                  <Route path={PATHS.LANDING}>
                    <Landing />
                  </Route>
                  <Route path={PATHS.LOGIN}>
                    <Login />
                  </Route>
                  <Route path={PATHS.REGISTER}>
                    <Register />
                  </Route>
                  <Route path={PATHS.RULES}>
                    <Rules />
                  </Route>
                  <Route path={PATHS.PRIVACY}>
                    <PrivacyPolicy />
                  </Route>
                  <Route path={PATHS.SCREENSHOTS}>
                    <Media />
                  </Route>
                  <Route path={PATHS.RECOVER_PASS}>
                    <RecoverPass />
                  </Route>
                  <Route path="*">
                    <Redirect to="/" replace />
                  </Route>
                </Switch>
              </Suspense>
            </div>
            <div className="public-footer">
              <NavLink to="/privacy">Privacy Policy</NavLink>
              <NavLink to="/rules">Rules</NavLink>
            </div>
          </main>
        </div>
      </div>
    </Suspense>
  );
};

export default Public;
